export default class StoryNavs {
    constructor() {
        this.root = document.querySelector(".js-story-navs");
        if (!this.root) return;

        this.scrollers = [...this.root.querySelectorAll(".js-story-navs-slider")];

        this.initScrollers();
        this.initTabs();
    }

    initScrollers() {
        this.scrollers.forEach((scroller) => {
            // アクティブ話が見える位置へ（表示中パネルのみ有効。非表示パネルは表示時に再実行）
            this.scrollActiveIntoView(scroller);

            // PC のマウスドラッグでも横スクロールできるように（タッチはネイティブ慣性に任せる）
            this.enableMouseDrag(scroller);

            // ドラッグ/スクロール直後のリンク遷移を抑止する
            this.preventLinkNavOnDrag(scroller);
        });
    }

    scrollActiveIntoView(scroller) {
        const active = scroller.querySelector(".story__navs__item.-active");
        if (!active) return;

        // アクティブ話を中央付近に寄せる（画面内に収まっていれば動かさない）
        const sr = scroller.getBoundingClientRect();
        const ar = active.getBoundingClientRect();
        const offset = ar.left - sr.left - (sr.width - ar.width) / 2;

        if (ar.left < sr.left || ar.right > sr.right) {
            scroller.scrollLeft += offset;
        }
    }

    enableMouseDrag(scroller) {
        let dragging = false;
        let startX = 0;
        let startScroll = 0;

        scroller.addEventListener("pointerdown", (e) => {
            if (e.pointerType !== "mouse") return; // タッチはネイティブスクロール
            dragging = true;
            startX = e.clientX;
            startScroll = scroller.scrollLeft;
            // ※ setPointerCapture は click のターゲットをこの要素へ奪ってしまい、
            //   話数リンクの遷移が効かなくなるため使わない
        });

        scroller.addEventListener("pointermove", (e) => {
            if (!dragging) return;
            scroller.scrollLeft = startScroll - (e.clientX - startX);
        });

        const end = () => {
            dragging = false;
        };
        scroller.addEventListener("pointerup", end);
        scroller.addEventListener("pointercancel", end);
        scroller.addEventListener("pointerleave", end);
    }

    // 一定距離動いた（＝ドラッグ/スクロール）直後のクリックによる話数ページ遷移をキャンセル
    preventLinkNavOnDrag(scroller) {
        let down = false;
        let startX = 0;
        let moved = false;

        scroller.addEventListener(
            "pointerdown",
            (e) => {
                down = true;
                startX = e.clientX;
                moved = false;
            },
            true
        );
        scroller.addEventListener(
            "pointermove",
            (e) => {
                // ポインタを押している間だけ判定する（ホバー移動でリンクを殺さない）
                if (!down) return;
                if (Math.abs(e.clientX - startX) > 10) moved = true;
            },
            true
        );
        const release = () => {
            down = false;
        };
        scroller.addEventListener("pointerup", release, true);
        scroller.addEventListener("pointercancel", release, true);

        scroller.addEventListener(
            "click",
            (e) => {
                if (moved) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                moved = false; // 次のクリックに持ち越さない
            },
            true
        );
    }

    initTabs() {
        const tabs = [...this.root.querySelectorAll(".story__navs__tab__item")];
        const panels = [...this.root.querySelectorAll(".story__navs__panel")];
        if (!tabs.length) return;

        tabs.forEach((tab) => {
            tab.addEventListener("click", () => {
                if (tab.classList.contains("-active")) return;

                const cour = tab.getAttribute("data-cour");

                tabs.forEach((t) => t.classList.toggle("-active", t === tab));
                panels.forEach((p) => {
                    const on = p.getAttribute("data-cour") === cour;
                    p.classList.toggle("-show", on);
                    if (on) {
                        const scroller = p.querySelector(".js-story-navs-slider");
                        if (scroller) this.scrollActiveIntoView(scroller);
                    }
                });
            });
        });
    }
}
